<template>
    <div>
        <div class="leaderBox" v-if="showOrhide">
            <div class="newtext">新手指引</div>
            <img src="../../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
            <img src="../../../assets/images/pop/tjlb/tjlb1.jpg" class="steps step1" v-if="status==1">
            <img src="../../../assets/images/pop/tjlb/tjlb2.jpg" class="steps step2" v-if="status==2" >
            <div class="stepbtn" @click="nextStep(status)">
                {{status==1?"下一步":status==2?"我知道了":"我知道了"}}
            </div>
            <div class="bottomTip">
                <el-checkbox v-model="checked">下次不再提示</el-checkbox>
            </div>
        </div>
        <!--        <breadcrumb :routerList="[{to:'/pricenewN',title:'特价管理'},{title:'特价列表'}]"/>-->
        <Breadtabsheader/>
        <div class="h-piece" style="margin:20px">
            <div class="h-formBox zhi" v-if="!checkFlag">
                <el-form :inline="true" class="demo-form-inline h-formBorder">
                    <el-form-item>
                        <el-button class="h-btn h-formBtn" icon="el-icon-plus" @click="chooseDingd">选择数据</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="h-pieceIn2">
                <div class="h-pieceTitle2" style="margin-left:10px">
                    <h1>报关草单信息</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine draft">
                        <el-form label-position="right" :inline="true" :model="formInline"
                                 class="h-formbLine">
                            <el-form-item label="境内发货人" class="h-elformWrap-2">
                                <el-input v-model="formInline.fhname" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="境外收货人" class="h-elformWrap-2">
                                <el-input v-model="formInline.shname" :disabled="!this.editFlag"></el-input>
                            </el-form-item>
                            <el-form-item label="生产销售单位" class="h-elformWrap-2">
                                <el-input v-model="formInline.productionUnit" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="合同协议号" class="h-elformWrap-2">
                                <el-input v-model="formInline.sapCode" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="贸易国" class="h-elformWrap-2">
                                <el-input v-model="formInline.soldToAreaName" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="运抵国" class="h-elformWrap-2">
                                <el-input v-model="formInline.shipToAreaName" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="件数" class="h-elformWrap-2">
                                <el-input v-model="formInline.number" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="毛重" class="h-elformWrap-2">
                                <el-input v-model="formInline.weight" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="净重" class="h-elformWrap-2">
                                <el-input v-model="formInline.netweight" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="成交方式" class="h-elformWrap-2">
                                <el-input v-model="formInline.gjmytk" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="运费" class="h-elformWrap-2">
                                <el-input v-model="formInline.feeyunf" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="保费" class="h-elformWrap-2">
                                <el-input v-model="formInline.feebaof" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="杂费" class="h-elformWrap-2">
                                <el-input v-model="formInline.feezaf" readonly></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
            <div class="h-row T-jia">
                <div class="h-rowIn" style="width:100%;">
                    <el-table
                            ref="multipleTable"
                            :data="formInline.detailList"
                            border
                            stripe
                            max-height="450"
                    >
                        <el-table-column
                                type="selection"
                                width="45"
                                label="全选"
                                fixed
                        >
                        </el-table-column>
                        <el-table-column
                                type="index"
                                width="40"
                                fixed
                                label="#">
                        </el-table-column>
                        <el-table-column
                                prop="materialCode"
                                label="商品编号"
                                :show-overflow-tooltip="true"
                                width="130">
                            <template scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.materialCode}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="additionalCode"
                                label="附加码"
                                :show-overflow-tooltip="true"
                                min-width="90">
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.additionalCode}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="materialName"
                                label="商品名称"
                                :show-overflow-tooltip="true"
                                width="150"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.materialName}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="materialType"
                                label="型号"
                                :show-overflow-tooltip="true"
                                width="130"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.materialType}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="number"
                                label="数量"
                                :show-overflow-tooltip="true"
                                width="80"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.number}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="unit"
                                label="单位"
                                :show-overflow-tooltip="true"
                                width="80"
                        >
                            <template slot-scope="scope">
                                {{scope.row.unit | dictname('YLUnit')}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="unitPrice"
                                label="单价"
                                width="80"
                                :show-overflow-tooltip="true"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.unitPrice}}
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column
                                prop="totalPrice"
                                label="总价"
                                width="80"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="currency"
                                label="币制"
                                width="80"
                        >
                            <template slot-scope="scope">
                                {{scope.row.unit | dictname('YLCurrency')}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="producingCuntry"
                                label="原产国"
                                width="110"
                        >
                            <template slot-scope="scope">
                                {{scope.row.producingCuntry | dictname('YLCountry_agent')}}
                            </template>
                        </el-table-column>

                        <el-table-column
                                prop="saleCountry"
                                width="80"
                                label="最终目的国">
                            <template slot-scope="scope">
                                {{scope.row.saleCountry | dictname('YLCountry_agent')}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="producingPlace"
                                width="110"
                                label="境内货源地">
                        </el-table-column>
                        <el-table-column
                                prop="zhengmian"
                                label="征免"
                                :show-overflow-tooltip="true"
                                width="80"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="netweight"
                                label="净重"
                                :show-overflow-tooltip="true"
                                width="80"
                        >
                        </el-table-column>
                        <el-table-column label="操作" width="100" v-if="!checkFlag" fixed="right">
                            <template slot-scope="scope">
                                <el-button
                                        type="text"
                                        size="small"
                                        class="h-tableLink h-btn"
                                        @click="deleteThis(scope.row)">
                                    删除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>

        <div class="center" style="margin-left: 400px;margin-top: 50px;">
            <el-button class="h-btn h-formBtn h-bgblueQ"  @click="saveDraft" v-if="!updateFlag && !checkFlag"
                       >保存
            </el-button>
            <el-button class="h-btn h-formBtn h-bgblueQ"  @click="updateDraft" v-if="updateFlag"
            >修改
            </el-button>
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                       @click="exportExcel">打印报关草单
            </el-button>
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                       @click="exportElementsExcel">申报要素导出
            </el-button>
        </div>
        <!--物料-->
        <wxdeclaration :visible.sync="updateVisDialogFlag"
                     v-if="updateVisDialogFlag"
                     @choseObj="choseOrder"
                     :usercode="this.formInline.soldToCode"
                     :sapCodeLike="this.sapCodeLike"
                     title="选择订单"/>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService'
    import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'
    import updownfile from '../../../utils/updownfile'
    import wxdeclaration from '../../../components/dialog/wx-declaration'
    export default {
        components: {
            uploaddownexcel,
            updownfile,
            wxdeclaration,
        },
        data() {
            return {
                tableData2:[],
                formInline: {
                    declarationCode: null,
                    detailList:[],
                    fhname:null,
                    shname:null,
                    productionUnit:null,
                    sapCode:null,
                    soldToAreaName:null,
                    shipToAreaName:null,
                    number:null,
                    weight:null,
                    netweight:null,
                    feeyunf:null,
                    feebaof:null,
                    feezaf:null,
                    gjmytk:null,
                    id:null,
                    saleGroup:null,
                    soldToCode:null,
                    soldToName:null,
                    orderList:[],
                },
                uploaddownexcelflag:false,
                showOrhide:false,
                updateVisDialogFlag:false,
                uptitleDig: null,
                isScreen: false,
                agentList:[],
                orderList:[],
                orderList1:[],
                sapCodeLike:'',
                id:null,
                updateFlag:false,
                editFlag:false,
                gscode:null,
                checkFlag:false,
            }
        },
        //加载页面默认执行
        created() {
            this.id = this.$route.query.id;
            if(this.$route.query.id){
                this.getDraftData(this.id);
                this.updateFlag = true;
            }
            if(this.$route.query.check){
                this.id = this.$route.query.check;
                this.getDraftData(this.id);
                this.checkFlag=true;
            }
            this.query();
        },
        mounted() {

        },
        methods: {
            // 展开折叠
            collapseChange(){
                this.isScreen = !this.isScreen;
            },
            showzhezhao(){
                ss.salesList.toshow(this.toshow).then(rd => {
                    console.log(rd)
                    if(rd == false){
                        this.showOrhide = false;
                    }else{
                        this.showOrhide = true;
                    }
                })
            },
            //重置
            resetData(){
                this.formInline.factory = null;
                this.formInline.materialCode = null;
            },
            //检索
            query(){
                ss.declaration.selectBgPage(this.formInline).then(rd => {
                    this.tableData2 = rd.records;
                    this.formInline.total = rd.total;
                })
            },
            //明细导出
            exportExcel() {
                updownfile.down('/api/swyl/v1/dingd/declaration/draft/downloadExcel',this.formInline,"post",'data');
            },
            //明细导出
            exportElementsExcel() {
                updownfile.down("/api/swyl/v1/dingd/declaration/oversea/downloadElementsExcel",this.formInline,"post",'data');
            },
            dateFormatter(v){
                var now = new Date(v);
                var year=now.getFullYear();
                var month = now.getMonth()+1 < 10?'0'+(now.getMonth()+1) : now.getMonth()+1;
                var alldata2 =  year+"-"+month;
                return alldata2;
            },
            formatDate(row, column) {
                // 获取单元格数据
                let data = row[column.property]
                if(data == null || data == '') {
                    return null
                }
                let dt = new Date(data)
                return this.$util.riQi3(dt);
            },
            ///


            //选择数据
            chooseDingd(){
                this.uptitleDig = '选择数据';
                this.updateVisDialogFlag = true;
            },
            //选择订单
            choseOrder(objs){
                this.orderList = [];
                this.updateVisDialogFlag = false;
                console.log("objs",objs)
                for(var i = 0;i<objs.length;i++){
                    var order = objs[i];
                    this.orderList.push(order);
                }
                var orderList2 = [];
                orderList2 = [...this.orderList,...this.orderList1];
                console.log("12312312312",orderList2)
                //获取订单产品报关主数据
                ss.declaration.getDeclaration(orderList2).then(rd => {
                    console.log("12345678",rd)
                    if(rd.f){
                        if(rd.msg.saleGroup == '9390'){
                            this.editFlag = true;
                        }
                        var id = this.formInline.id;
                        this.formInline = rd.msg;
                        this.formInline.id = id;
                        this.sapCodeLike = '';
                        for(var j = 0;j<this.formInline.detailList.length;j++){
                            var declaration = this.formInline.detailList[j];
                            if(j < this.formInline.detailList.length-1){
                                this.sapCodeLike = this.sapCodeLike + declaration.orderId + ",";
                            }else {
                                this.sapCodeLike = this.sapCodeLike + declaration.orderId;
                            }
                        }
                        for(var k = 0;k<this.orderList.length;k++){
                            var order = this.orderList[k];
                            this.orderList1.push(order);
                        }
                        console.log("23232323223", this.orderList1)
                    }

                })
            },
            //删除
            deleteThis(row) {

                console.log(row,"删除");
                var orderId = row.orderId;
                this.$msg.confirm("确认删除？", () => {
                    this.formInline.detailList = _.reject(this.formInline.detailList, {'orderId': orderId});
                    this.orderList1 = _.reject(this.orderList1,{'bid':orderId});
                    this.sapCodeLike = '';
                    for(var j = 0;j<this.formInline.detailList.length;j++){
                        var declaration = this.formInline.detailList[j];
                        if(j < this.formInline.detailList.length-1){
                            this.sapCodeLike = this.sapCodeLike + declaration.orderId + ",";
                        }else {
                            this.sapCodeLike = this.sapCodeLike + declaration.orderId;
                        }
                    }
                })


            },
            //保存报关草单
            saveDraft(){
                var data = {};
                data = this.formInline;
                this.$msg.confirm("确认提交？", () => {
                    ss.declaration.saveDraft(data).then(rd => {
                        if(rd.f){
                            this.$router.push({path: '/declaration/draftDeclaration'})
                        }
                    })
                })
            },
            //修改报关草单
            updateDraft(){
                var data = {};
                data = this.formInline;
                this.$msg.confirm("确认提交？", () => {
                    ss.declaration.updateDraft(data).then(rd => {
                        if(rd.f){
                            this.$router.push({path: '/declaration/draftDeclaration'})
                        }
                    })
                })
            },
            getDraftData(v){
                ss.declaration.selectByDraftId(v).then(rd => {
                    if(rd.f){
                        if(rd.msg.saleGroup == '9390'){
                            this.editFlag = true;
                        }
                        this.formInline = rd.msg;
                        for(var i = 0;i<this.formInline.orderList.length;i++){
                            var order = this.formInline.orderList[i];
                            this.orderList.push(order);
                        }
                    }
                })
            },
        }
    }
</script>
<style scoped>
    .selectorBox {
        width: 100%;
        padding: 0.54rem 0.28rem 0 0.25rem;
    }
    .selectorBox .text {
        margin-left: 0.38rem;
        font-size: 0.18rem;
        color: #4a4a4a;
        position: relative;
    }
    .selectorBox .text::before {
        content: "*";
        position: absolute;
        top: 0;
        left: -7px;
        color: red;
        font-size: 0.2rem;
    }
    .selectorBox .selector {
        margin-left: 0.38rem;
        margin-top: 20px;
        display: flex;
    }
    .selectorBox .selector .button {
        width: 65px;
        padding: 10px;
        color: #b7b7b7;
        border: 1px solid #dcdfe1;
        text-align: center;
        line-height: 20px;
        cursor: pointer;
    }
    .selectorBox .selector .button.active {
        color: #fff;
        background: #238cfd;
        border: 1px solid #238cfd;
    }
    .T-jia .h-btn.el-button.h-tableLink{
        padding: 0 0.05rem;
    }
    #xcv {
        padding: 0.14rem 0.2rem;
        font-size: 0.18rem;
        color: #fff;
        letter-spacing: 0.02rem;
        border: 1px solid #24b5b8;
        background: #24b5b8;
        border-radius: 0.04rem;
        line-height: 0.18rem;
    }
</style>
<style>
    .X-la .h-formbLine .el-form-item__content .el-select{
        width: 100%!important;
    }
    .zhi .el-date-editor .el-range-separator{
        width:13%;
        margin-bottom:7px;
    }
    .selectorBox .el-input-group__append {
        background: #238cfd;
        color: #fff
    }
    .selectorBox .el-upload-list {
        display: none;
    }

    .draft .h-formbLine .h-elformWrap-2 {
        padding-right: 0.1rem;
        width: 33%;
    }
    .draft .h-formbLine .h-elformWrap-2 .el-form-item__label {
        width: 50%;
    }

    .draft .h-formbLine .h-elformWrap-2 .el-form-item__content {
        width: 50%;
    }

</style>
